import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className = 'h-6 w-6' }) => (
  <span aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
      {/* Background circle */}
      <circle cx="12" cy="12" r="12" fill="#DF2429" />

      {/* White X */}
      <path
        fill="#FFFFFF"
        d="M8.4 17l3.6-3.6 3.6 3.6 1.4-1.4-3.6-3.6L17 8.4 15.6 7 12 10.6 8.4 7 7 8.4l3.6 3.6L7 15.6 8.4 17z"
      />
    </svg>
  </span>
);

export default Icon;
